<template>
    <v-row justify="center" align="center" class="bod_back_img">
        <v-col align="center">
            <v-overlay :value="overlay">
                <v-progress-circular
                    :size="70"
                    :width="7"
                    color="gray"
                    indeterminate
                    ></v-progress-circular>
            </v-overlay>
            
            <!-- <v-row class="solid_width">
                <v-col class="text-left px-0">
                    <span style="font-size:24px;">
                        {{ pathwayTitle }}
                    </span>
                </v-col>
            </v-row> -->
            <!-- select pathway -->
            <v-row class="solid_width mt-0">
                <v-col class="px-0">
                    <v-card-actions class="pl-0">
                        <v-autocomplete clearable hide-details outlined dense 
                            background-color="#E0F2F1"
                            style="max-width: 40%;"
                            class="mr-2"
                            :items="select_pathways"
                            :label="selectLabel"
                            v-model="current_pathway"></v-autocomplete>
                        <v-btn rounded @click="select_new_pathway" color="#007684">
                            <span style="color: white;">Go</span>
                        </v-btn>
                        <v-spacer></v-spacer>

                        <v-autocomplete
                            outlined
                            color="#31a3a2" 
                            dense
                            v-model="search_gene" 
                            :items="all_objs"
                            class="ml-6" 
                            style="margin-bottom: -26px;max-width:400px;min-width:400px;"
                            placeholder="Search gene by gene/miRNA/LncRNA" 
                            :error-messages="no_search_gene"
                            >
                        </v-autocomplete>
                        <!-- <v-text-field 
                            outlined 
                            color="#31a3a2" 
                            dense 
                            v-model="search_gene" 
                            class="ml-6" 
                            style="margin-bottom: -26px;max-width:400px;min-width:400px;"
                            placeholder="Search gene by gene/miRNA/LncRNA" 
                            :error-messages="no_search_gene">
                        </v-text-field> -->
                        <v-btn class="text-none ml-3 white--text" color="#007684" >Search</v-btn>
                        <v-spacer></v-spacer>

                        <v-tooltip left color="#E0F2F1">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                color="#007684"
                                v-bind="attrs"
                                v-on="on"
                                class="mr-5"
                                >
                                mdi-lightbulb-question-outline
                                </v-icon>
                            </template>
                            <div class="text-justify font-italic font-weight-light" style="color: #007684;">
                                <p class="ma-0 text-body-2">Note:</p>
                                <p class="ma-0 text-body-2">1.Press Enter to lock the current tooltip.</p>
                                <p class="ma-0 text-body-2">2.Press Esc to unlock the current tooltip.</p>
                            </div>
                        </v-tooltip>

                        <v-btn rounded @click="click_back" color="#007684">
                            <span style="color: white;" class="text-none">Return</span>
                            <v-icon right color="white">mdi-keyboard-return</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-col>
            </v-row>
            <!-- gene node -->
            <v-row style="background-color: white;" class="solid_width elevation-2 mb-6">

                <v-col style="max-width: 1200px;min-width: 1200px;" class="pa-0">
                    <div :style="background" id="pathway">

                        <template v-if="!current_pathway">
                            
                            <v-row justify="center" align="center" dense class="mx-3" style="top: 600px; max-width: 1150px;position: absolute;">
                                
                                <v-col cols="4" class="px-1" align-self="center">
                                    <v-card>
                                        <v-card-title class="table-title pa-0" style="height: 50px;align-content: center;justify-content: center;">
                                            <div :style="iconStatistic"></div>
                                            <span class="text-h6 white--text">Number of targets for miRNAs</span>
                                        </v-card-title>
                                        <v-card-text class="pa-0">
                                            <v-data-table
                                                :headers="allMirnaTargetNumberHeader"
                                                :items="allMirnaTargetNumber"
                                                :server-items-length="allMirnaTargetNumberCount"
                                                :loading="allMirnaTargetNumberOverlay"
                                                :footer-props="{'items-per-page-options': [100]}"
                                                :page="allMirnaTargetNumberPage"
                                                style="max-height: 500px;"
                                                class="elevation-1 overflow-auto"
                                                @update:options="options => allMirnaTargetNumberOptions=options" >
                                                <template v-slot:[`item.miRNA`]="{ item }">
                                                  <a :href="'/#/SearchDetail?categoryText=MiRNA&category=mirna&search='+item.miRNA" target="_blank">{{item.miRNA}}</a>
                                                </template>
                                                <template v-slot:[`footer.page-text`]="{pageStart, pageStop, itemsLength}">
                                                    <span>{{pageStart}}-{{pageStop}} of {{itemsLength}}</span><span class="ml-1">Page:</span>
                                                    <v-text-field 
                                                        dense hide-details hide-spin-buttons 
                                                        type="number" 
                                                        class="d-inline-block ml-2 text-caption" style="max-width:15%" v-model="allMirnaTargetNumberPage"></v-text-field>
                                                </template>
                                            </v-data-table>
                                        </v-card-text>
                                    </v-card>
                                </v-col>

                                <v-col cols="4" class="px-1" align-self="center">
                                    <v-card>
                                        <v-card-title class="table-title pa-0" style="height: 50px;align-content: center;justify-content: center;">
                                            <div :style="iconStatistic"></div>
                                            <span class="text-h6 white--text">Number of targets for lncRNAs</span>
                                        </v-card-title>
                                        <v-card-text class="pa-0">
                                            <v-data-table
                                                :headers="allLncrnaTargetNumberHeader"
                                                :items="allLncrnaTargetNumber"
                                                :server-items-length="allLncrnaTargetNumberCount"
                                                :loading="allLncrnaTargetNumberOverlay"
                                                :footer-props="{'items-per-page-options': [100]}"
                                                :page="allLncrnaTargetNumberPage"
                                                style="max-height: 500px;"
                                                class="elevation-1 overflow-auto"
                                                @update:options="options => allLncrnaTargetNumberOptions=options" >
                                                <template v-slot:[`item.lncRNA`]="{ item }">
                                                  <a :href="'/#/SearchDetail?categoryText=LncRNA&category=lncrna&search='+item.lncRNA" target="_blank">{{item.lncRNA}}</a>
                                                </template>
                                                <template v-slot:[`footer.page-text`]="{pageStart, pageStop, itemsLength}">
                                                    <span>{{pageStart}}-{{pageStop}} of {{itemsLength}}</span><span class="ml-1">Page:</span>
                                                    <v-text-field 
                                                        dense hide-details hide-spin-buttons 
                                                        type="number" 
                                                        class="d-inline-block ml-2 text-caption" style="max-width:15%" v-model="allLncrnaTargetNumberPage"></v-text-field>
                                                </template>
                                            </v-data-table>
                                        </v-card-text>
                                    </v-card>
                                </v-col>

                                <v-col cols="4" class="px-1" align-self="center">
                                    <v-card>
                                        <v-card-title class="table-title pa-0" style="height: 50px;align-content: center;justify-content: center;">
                                            <div :style="iconStatistic"></div>
                                            <span class="text-h6 white--text">Data statistical table</span>
                                        </v-card-title>
                                        <v-card-text class="pa-0">
                                            <v-data-table
                                                :headers="allGeneTargetNumberHearder"
                                                :items="allGeneTargetNumber"
                                                :server-items-length="allGeneTargetNumberCount"
                                                :loading="allGeneTargetNumberOverlay"
                                                :footer-props="{'items-per-page-options': [100]}"
                                                :page="allGeneTargetNumberPage"
                                                style="max-height: 500px;"
                                                class="elevation-1 overflow-auto"
                                                @update:options="options => allGeneTargetNumberOptions=options" >
                                                <template v-slot:[`item.gene`]="{ item }">
                                                  <a :href="'/#/SearchDetail?categoryText=Gene&category=gene&search='+item.gene" target="_blank">{{item.gene}}</a>
                                                </template>
                                                <template v-slot:[`footer.page-text`]="{pageStart, pageStop, itemsLength}">
                                                    <span>{{pageStart}}-{{pageStop}} of {{itemsLength}}</span><span class="ml-1">Page:</span>
                                                    <v-text-field 
                                                        dense hide-details hide-spin-buttons 
                                                        type="number" 
                                                        class="d-inline-block ml-2 text-caption" style="max-width:15%" v-model="allGeneTargetNumberPage"></v-text-field>
                                                </template>
                                            </v-data-table>
                                        </v-card-text>
                                    </v-card>
                                </v-col>

                            </v-row>
                        </template>

                        <table :width="normalized_table_width" :style="table_style" cellspacing="0" cellpadding="0" ref="geneTable">
                            <tr v-for="row in table_scale[0]" :key="'row'+row">
                                <td 
                                    v-for="col in table_scale[1]" 
                                    :key="'col'+col"
                                    :width="normalized_cell_size[0]+'px'"
                                    :height="normalized_cell_size[1]+'px'"
                                    :class="{'box-shadow-gene': is_reversed(row-1, col-1), 'selected-gene': is_selected(row-1, col-1)}"
                                    class="rounded-lg"
                                    @mouseenter="select_gene_node(row-1, col-1)"
                                    @mousemove="updateXY"
                                    @click="click_gene_node(row-1, col-1)">

                                        <v-badge
                                            v-if="is_gene_node(row-1, col-1)"
                                            offset-x="-6"
                                            offset-y="-10"
                                            color="error"
                                            overlap
                                            :content="gene_relation_counts(row-1, col-1)">
                                        </v-badge>

                                        <!-- <template v-else>
                                            {{(row-1)+'-'+(col-1)}}
                                        </template> -->
                                
                                </td>
                            </tr>
                        </table>
                        <div class="geneDetailTab rounded-lg" v-show="seen" :style="geneDetailPos">
                            
                            <div :style="genDetailTabBody">
                                <v-row align="center" justify="center" class="geneDetail" no-gutters>
                                    <v-col class="geneNode rounded-xl" cols="6">

                                        <v-badge
                                            offset-x="0"
                                            offset-y="0"
                                            color="error"
                                            overlap
                                            v-if="geneDetailRefCounts>0"
                                            :content="geneDetailRefCounts">

                                            <span class="font-weight-black">{{ current_gene_node }}</span>
                                            
                                        </v-badge>
                                        <span v-else class="font-weight-black">{{ current_gene_node }}</span>
                                        
                                    </v-col>

                                    <v-col cols="6">
                                        <v-row align="center" justify="center">
                                            <v-col class="rounded-xl">
                                                <span class="geneRel white--text font-weight-black font-italic rounded-lg">miRNA</span>
                                                <span class="geneCount">{{relation_tabs[0].strong.length + relation_tabs[0].weak.length}}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row align="center" justify="center">
                                            <v-col class="rounded-xl">
                                                <span class="geneRel white--text font-weight-black font-italic rounded-lg">LncRNA</span>
                                                <span class="geneCount">{{relation_tabs[1].strong.length + relation_tabs[1].weak.length}}</span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </div>
                            

                        </div>
                    </div>
                </v-col>

                <v-col style="max-width: 240px;min-width: 240px;" class="pa-auto">
                    <div style="max-width: 220px;min-width: 220px;" :class="{'float-div':is_float}">
                        <v-card class="mb-2 rounded-lg">
                            <v-tabs grow v-model="current_relation_index" background-color="#B7CACE" color="white" active-class="blue-grey lighten-2 rounded-lg active-tab" hide-slider>
                                <v-tab v-for="tab in relation_tabs" class="px-0" :key="tab.text" style="flex-direction: column;">
                                    <span class="text-none">{{tab.text}}</span>
                                    <span class="">{{tab.strong.length + tab.weak.length}}</span>
                                </v-tab>
                            </v-tabs>
                        </v-card>

                        <v-card  height="360px" color="#B6CBCF" class="mb-1 rounded-lg">
                            <v-tabs-items v-model="current_relation_index">
                                <v-tab-item v-for="tab in relation_tabs" :key="tab.text + 'Strong'">
                                        <v-list color="#B6CBCF">
                                            <v-list-item>
                                                <v-list-item-title class="text-subtitle-1 text-left">Strong</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item-group style="max-height: 236px;" class="overflow-auto">
                                            <template v-for="s in tab.strong">
                                                <v-list-item :key="s" @mouseenter="select_tab_node(current_relation_index, s)" @mouseleave="clean_tab_node" @click="click_tab_node(tab.text, tab.key, true, s)">
                                                    <v-list-item-subtitle  v-text="'· ' + s" class="under-line text-left"></v-list-item-subtitle>
                                                </v-list-item>
                                            </template>
                                        </v-list-item-group>
                                    </v-list>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-card>

                        <v-card  height="360px" color="#CBD9DD" class="rounded-lg">
                            <v-tabs-items v-model="current_relation_index">
                                <v-tab-item v-for="tab in relation_tabs" :key="tab.text + 'Weak'">
                                    <v-list color="#CBD9DD">
                                        <v-list-item>
                                            <v-list-item-title class="text-subtitle-1 text-left">Weak</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item-group style="max-height: 236px;" class="overflow-auto">
                                            <template v-for="w in tab.weak">
                                                <v-list-item :key="w" @mouseenter="select_tab_node(current_relation_index, w)" @mouseleave="clean_tab_node" @click="click_tab_node(tab.text, tab.key, false, w)">
                                                    <v-list-item-subtitle v-text="'· ' + w" class="under-line text-left"></v-list-item-subtitle>
                                                </v-list-item>
                                            </template>
                                        </v-list-item-group>
                                    </v-list>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-card>
                    </div>

                </v-col>

            </v-row>

        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "BrowsePage",
    data: () => ({
        table_style: {
            "table-layout": "fixed",
            "text-align": "center"
        },
        table_scale: [40, 20],  // table的默认shape
        normalized_table_width: 1200,
        normalized_cell_size: [60, 24],

        overlay: false,

        search_gene: "",
        miOrLnc: null,
        no_search_gene: null,
        all_objs: [],

        pathwayTitle: 'Choose Pathway',

        select_pathways: [
            {"text": "---------------", "value": "---------------", "disabled": true},
        ],
        pathwaysTxtVal: null,
        pathwaysValTxt: null,
        current_pathway: "---------------",
        // current_pathway: "3.2-HIF-1 signaling pathway - Homo sapiens (human)-hsa04066",
        current_pathway_image_url: "static/img_browse/defaultBkg.png",
        current_pathway_coord: null,

        current_gene_node: null,

        relation_tabs: [
            {"text": "miRNA", "key": "mirna", "strong": [], "weak": []},
            {"text": "LncRNA", "key": "lncrna", "strong": [], "weak": []},
            // {"text": "cirRNA", "strong": [], "weak": []},
        ],
        relation_tabs_addition: null,
        current_relation_index: null,

        reverse: {},
        current_relation_node: null,

        last_pathways: [],
        scrollY: 0,

        posX: 0, 
        posY: 0,

        locked: false,  // 锁定悬浮窗

        // 新增三个页面table
        allGeneTargetNumberHearder: [
            {text: "Gene", value: "gene"},
            {text: "Number of relevant miRNA", value: "target_number_mirna"},
            {text: "Number of relevant lncRNA", value: "target_number_lncrna"},
            {text: "Total", value: "target_total"},
        ],
        allGeneTargetNumber: [],
        allGeneTargetNumberOptions: {},
        allGeneTargetNumberOverlay: false,
        allGeneTargetNumberCount: 0,
        allGeneTargetNumberPage: 1,

        allLncrnaTargetNumberHeader: [
            {text: "lncRNA", value: "lncRNA"},
            {text: "Number of targets for lncRNAs", value: "target_number"},
        ],
        allLncrnaTargetNumber: [],
        allLncrnaTargetNumberOptions: {},
        allLncrnaTargetNumberOverlay: false,
        allLncrnaTargetNumberCount: 0,
        allLncrnaTargetNumberPage: 1,

        allMirnaTargetNumberHeader: [
            {text: "miRNA", value: "miRNA"},
            {text: "Number of targets for miRNAs", value: "target_number"},
        ],
        allMirnaTargetNumber: [],
        allMirnaTargetNumberOptions: {},
        allMirnaTargetNumberOverlay: false,
        allMirnaTargetNumberCount: 0,
        allMirnaTargetNumberPage: 1,
    }),
    methods: {
        
        select_new_pathway: function(){
            if(!this.current_pathway) return
            if(this.last_pathways&&this.last_pathways[this.last_pathways.length-1]==this.current_pathway) return
            this.get_pathway_detail();
        },
        
        select_gene_node(row, col){
            if(this.locked) return
            let val = this.get_gene_node(row, col);
            if(!val){
                this.current_gene_node = null;
                return
            }
            this.current_gene_node = val;
            let addition = this.relation_tabs_addition[val];
            for(let i=0;i<this.relation_tabs.length;i++){
                let tab = this.relation_tabs[i];
                tab.strong = [];
                tab.weak = [];
                if(!addition) continue
                tab.strong = addition[i].strong;
                tab.weak = addition[i].weak;
            }
        },
        get_gene_node(row, col){
            if(!this.current_pathway_coord) return false
            let row_data = this.current_pathway_coord[row];
            if(!row_data) return false
            let col_data = row_data[col];
            if(!col_data) return false
            return col_data
        },
        // 小红点判断
        is_gene_node(row, col){
            let val = this.get_gene_node(row, col);
            if(!val) return false
            let _counts = this.gene_relation_counts(row, col);

            if(!_counts) return false
            if(!this.pathwaysTxtVal.has(val)) return true
            return false
        },
        gene_relation_counts(row, col){
            let val = this.get_gene_node(row, col);
            if(!val) return false
            let relation = this.relation_tabs_addition[val];
            if(!relation) return false
            let counts = 0;
            for(let obj of relation){
                counts += obj.strong.length;
                counts += obj.weak.length;
            }
            return counts
        },
        click_gene_node(row, col){
            if(!this.current_gene_node) return
            let _pathway = this.pathwaysTxtVal.get(this.processVal(this.current_gene_node));
            if(_pathway){
                this.current_pathway = _pathway;
                this.select_new_pathway();
                return
            }
            let _counts = this.gene_relation_counts(row, col);
            if(!_counts) return false
            let url = this.$router.resolve({
                name: "BrowseDetail",
                query: {
                    pathway: this.current_pathway,
                    gene: this.current_gene_node
                }
            })
            window.open(url.href, "_blank")
        },

        select_tab_node(category_index, val){
            let category = this.relation_tabs[category_index].text;
            this.current_relation_node = val;
        },
        clean_tab_node(){
            this.current_relation_node = null;
        },
        is_reversed(row, col){
            let val = this.get_gene_node(row, col);
            if(!val || !this.reverse) return false
            let relation_reverse = this.reverse[this.current_relation_node];
            if(!relation_reverse) return false
            if(relation_reverse.includes(val)) return true
            return false
        },
        is_selected(row, col){
            if(!this.current_pathway_coord || !this.search_gene) return false
            let val = this.get_gene_node(row, col);
            let geneList = this.miOrLnc.get(this.search_gene.toLowerCase());
            if(val!==false && geneList && geneList.length>0){
                let gotIt = false;
                for(let gene of geneList){
                    if(gene.toLowerCase() == val.toLowerCase()){
                        gotIt = true
                        break
                    }
                }
                if(gotIt) return gotIt
            }
            if(val===false) return val
            return val.toLowerCase() == this.search_gene.toLowerCase()
        },
        click_back: function(){
            if(this.last_pathways.length>1){
                this.last_pathways.pop();
                this.current_pathway = this.last_pathways.pop();
                this.select_new_pathway();
            }
        },
        click_tab_node(category_text, category_key, strong, val){
            let pathwayText = null;
            for (const item of this.select_pathways) {
                if(item.value == this.current_pathway){
                    pathwayText = item.text;
                    break
                }
            }

            let url = this.$router.resolve({
                name: "SearchDetail",
                query: {
                    categoryText: category_text,
                    category: category_key,

                    pathway: this.current_pathway,
                    pathwayText: pathwayText,

                    strong: strong,
                    search: val
                }
            })
            window.open(url.href, "_blank")
        },
        get_pathway_dataset: function(){
            this.overlay = true;
            let successCb = res => {
                let data = res.data;
                this.select_pathways = data.allowed_pathways;
                let new_objs = [];
                this.select_pathways.forEach( ele => {
                    new_objs.push({text: `${ele.text}(${ele.value})`, value: ele.value})
                    this.pathwaysTxtVal.set(this.processVal(ele.text), ele.value);
                    this.pathwaysValTxt.set(ele.value, ele.text);
                })
                this.select_pathways = new_objs;
                if(this.current_pathway) this.select_new_pathway()
            }
            this.axios.get(
                "/browsePathways"
            ).then( res => successCb(res))
            .finally( () => {this.overlay = false})
        },
        get_pathway_detail: function(){
            this.overlay = true;
            let successCb = res => {
                let response_data = res.data;
                this.pathwayTitle = this.pathwaysValTxt.get(this.current_pathway);
                this.last_pathways.push(this.current_pathway);
                this.current_pathway_image_url = response_data.url;
                this.current_pathway_coord = response_data.coordinates;
                this.relation_tabs_addition = response_data.relation_tabs;
                this.reverse = response_data.reverse_tabs;
                let _map = new Map();
                for(let [key, value] of Object.entries(response_data.reverse_tabs)){
                    _map.set(key.toLowerCase(), value)
                }
                this.miOrLnc = _map;
                this.getImgInfo();
                this.locked = false; // 重置锁定

                // 所有数据合并方便搜索框模糊查询
                let objs = new Set();
                for (const key in this.relation_tabs_addition) {
                    objs.add(key)
                    for (const {strong, weak} of this.relation_tabs_addition[key]) {
                        strong.forEach( v => objs.add(v) )
                        weak.forEach( v => objs.add(v) )
                    }
                }
                Object.entries(this.reverse).forEach( ([key, val]) => {
                    objs.add(key)
                    val.forEach( v => objs.add(v))
                })
                for (const val of objs) {
                    this.all_objs.push(
                        {"text": val, "value": val}
                    )
                }
            }
            this.axios.get(
                "/browsePathwayDetail",
                {params: {"pathway": this.current_pathway}}
            ).then( res => successCb(res))
            .finally( () => {this.overlay = false})
        },
        processVal: function(val){
            return val.toLowerCase().replace(/\s*/g, "")
        },

        // 切换pathway之后调用
        getImgInfo() {
            let img = new Image();
            img.src = this.current_pathway_image_url;
            const vm = this;
            img.onload = function () {
                const scale = img.width / vm.normalized_table_width;
                let col = (img.width / scale) / vm.normalized_cell_size[0];
                let row = (img.height / scale) / vm.normalized_cell_size[1];
                vm.table_scale =  [Math.ceil(row), Math.ceil(col)];
            }
        },

        updateXY(e){
            if(this.locked) return
            this.posX = e.pageX;
            this.posY = e.pageY;
            // this.posX = e.screenX + document.documentElement.scrollLeft + document.body.scrollLeft;
            // this.posY = e.screenY + document.documentElement.scrollTop + document.body.scrollTop;
        },

        lockGene: function(env){
            // 13 == enter 27 == esc
            if(env.keyCode == 13 && this.current_gene_node) this.locked = true;
            else if(env.keyCode == 27 && this.current_gene_node) this.locked = false;
        },

        // 页面上表格数据获取
        getGeneTargetNumber: function(options) {
            if(!options) return
            let params = {
                page: options.page, 
                sortBy: options.sortBy?options.sortBy[0]:null, 
                sortDesc: options.sortDesc[0]
            }
            this.allGeneTargetNumberOverlay = true
            this.axios.get(
                "/getGeneTargetNumber",
                {params: params}
            ).then(resp => {
                let data = resp.data;
                if(!data.data) return 
                this.allGeneTargetNumber = data.data
                this.allGeneTargetNumberCount = data.count
            }).finally(()=>{
                this.allGeneTargetNumberOverlay = false
            })
        },
        getLncrnaTargetNumber: function(options) {
            if(!options) return
            let params = {
                page: options.page, 
                sortBy: options.sortBy?options.sortBy[0]:null, 
                sortDesc: options.sortDesc[0]
            }
            this.allLncrnaTargetNumberOverlay = true
            this.axios.get(
                "/getLncrnaTargetNumber",
                {params: params}
            ).then(resp => {
                let data = resp.data;
                if(!data.data) return 
                this.allLncrnaTargetNumber = data.data
                this.allLncrnaTargetNumberCount = data.count
            }).finally(()=>{
                this.allLncrnaTargetNumberOverlay = false
            })
        },
        getMirnaTargetNumber: function(options) {
            if(!options) return
            let params = {
                page: options.page, 
                sortBy: options.sortBy?options.sortBy[0]:null, 
                sortDesc: options.sortDesc[0]
            }
            this.allMirnaTargetNumberOverlay = true
            this.axios.get(
                "/getMirnaTargetNumber",
                {params: params}
            ).then(resp => {
                let data = resp.data;
                if(!data.data) return 
                this.allMirnaTargetNumber = data.data
                this.allMirnaTargetNumberCount = data.count
            }).finally( () => {
                this.allMirnaTargetNumberOverlay = false
            })
            
        },
    },
    computed: {
        selectLabel: function(){
            if(this.current_pathway) return undefined
            return "Choose Pathway"
        },
        background: function(){
            return {
                "backgroundImage": "url('" + this.current_pathway_image_url + "')",
                "background-repeat":"no-repeat",
                "background-size": '100%',
                "width": this.normalized_table_width + 'px',
                "text-align": "center"
            }
        },
        is_float: function(){
            if(this.scrollY>=300) return true
            return false
        },
        geneDetailPos: function(){
            let _X = document.body.clientWidth * 2 / 3;
            if(this.posX < _X){
                return {
                    left : this.posX + 20 + "px",
                    top: this.posY - 50 + "px",
                    // top: this.posY - 150 + "px",
                }
            }else{
                return {
                    left : this.posX - 250 + "px",
                    top: this.posY - 50 + "px",
                    // top: this.posY - 150 + "px",
                }
            }
        },
        genDetailTabBody: function(){
            return {
                height: "100px",
                width: "100%",
                backgroundImage: "url('static/img_browse/connection.png')",
                padding: "15px 5px 0 5px",
            }
        },
        geneDetailRefCounts: function(){
            let a = 0;
            for(let tab of this.relation_tabs){
                a += tab.strong.length;
                a += tab.weak.length;
            }
            return a 
        },
        seen: function(){
            if(this.locked) return true
            if(this.current_gene_node && !this.pathwaysTxtVal.has(this.processVal(this.current_gene_node))) return true
            return false
        },
        iconStatistic: function(){
            return {
                "backgroundImage": "url('static/statistic.png')",
                "background-repeat":"no-repeat",
                "height": "28px",
                "width": "28px",
                "background-size": '100%',
                "text-align": "center"
            }
        }
    },
    watch: {
        locked: function(newVal, oldVal){
            if(newVal === false) this.current_gene_node = null;
        },
        search_gene: function(nVal, oVal){
            this.no_search_gene = null;
            if(!nVal) return
            this.$nextTick(function(){
                let nodes = this.$refs["geneTable"].getElementsByClassName("selected-gene");
                if(nodes.length > 0) return
                this.no_search_gene = "Your search target is not in this pathway, please check the input."
            })
        },
        allGeneTargetNumberOptions: function(nV, oV) {
            this.getGeneTargetNumber(nV)
        },
        allLncrnaTargetNumberOptions: function(nV, oV) {
            this.getLncrnaTargetNumber(nV)
        },
        allMirnaTargetNumberOptions: function(nV, oV) {
            this.getMirnaTargetNumber(nV)
        },
    },
    // 组件挂载的后加载下拉框内容
    created: function(){
        this.get_pathway_dataset();
        this.pathwaysTxtVal = new Map();
        this.pathwaysValTxt = new Map();
    },
    mounted: function(){
        // 滚动事件
        window.addEventListener('scroll',()=>{this.scrollY = window.scrollY});
        // 悬浮窗锁定
        document.addEventListener("keyup", this.lockGene);
        this.current_pathway = this.$route.query.pathway;
    }

}
</script>

<style scoped>
a{ text-decoration:none}
a:hover{ text-decoration:none}
.float-div{
    position: fixed!important;
    top: 5px!important;
}
.geneDetailTab{
    position: absolute;
    width: 230px;
    
    background-color: rgba(49, 163, 162, .5);
    border:1px solid #ffffff;
}
.geneNode{
    border:2px solid #ffffff;
    background-color: #31A3A2;
    width: 75%;
}
.geneRel{
    border:2px solid #ffffff;
    background-color: #007A86;
    padding: 3px;
}
.geneCount{
    border:2px solid orange;
    background-color: #ffffff;
    padding: 3px;
}
.v-list-item{
    min-height: 25px;
}
.active-tab{
    padding: 0;
}
/* .box-shadow-gene{
    -webkit-box-shadow:inset 0 0 3px 3px red;
    -moz-box-shadow:inset 0 0 3px 3px red;
    box-shadow:inset 0 0 3px 3px red;
} */

.box-shadow-gene {
    /* box-shadow: inset -5px 5px 3px 3px red; */
    outline: 3px solid orange;
    outline-offset: 2px;
}

.selected-gene {
    outline: 3px solid red;
    outline-offset: 2px;
}

.table-title {
    background-color: #31A3A2;
}

/deep/ .v-data-footer__pagination {
    width: 50% !important;
}

</style>